import { _, tinycolor, Papa } from "js/vendor";
import { app } from "js/namespaces";
import * as analytics from "js/analytics";
import perf from "./perf";
import jsSHA from "jssha";
import { v4 } from "uuid";

export function uuid() {
    return v4();
}

export function getCode(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result.toUpperCase();
}

export function getQueryVariables(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

export function objectToArray(obj) {
    if (obj) {
        return _.map(obj, o => o);
    } else {
        return null;
    }
}

export function arrayToObject(array) {
    let o = {};
    for (let i = 0; i < array.length; i++) {
        o[i] = array[i];
    }
    return o;
}

export function objectDiff(object, base) {
    if (!object || !base) return {};

    function changes(object, base) {
        return _.transform(object, function(result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

export function isObjectDiff(object, base) {
    return Object.keys(objectDiff(object, base)).length != 0 || Object.keys(objectDiff(base, object)).length != 0;
}

export function convertCSSValue(value) {
    if (typeof value == "number") return value;
    if (value == undefined || value == null || value == "") {
        return 0;
    }
    var val = parseInt(value.replace(/%|px/, ""));
    if (value.indexOf("%") == -1) {
        return val;
    } else {
        return val / 100;
    }
}

export function getSizingValue(value, max) {
    if (typeof value == "number") return value;
    if (value == undefined || value == null || value == "") {
        return max;
    }
    var val = parseInt(value.replace(/%|px/, ""));
    if (value.indexOf("%") == -1) {
        return val;
    } else {
        return val / 100 * max;
    }
}

export function getCustomProperties(styles) {
    if (!styles) return null;
    var props = styles.content;

    if (!props) return null;

    //trim quotes
    props = props.substr(1, props.length - 2);

    var customProps = {};

    _.each(props.split(";"), prop => {
        customProps[prop.split(":")[0]] = prop.split(":")[1];
    });

    return customProps;
}

export function getPadding($el) {
    var padding = {};

    padding.left = parseInt($el.css("padding-left")) || 0;
    padding.top = parseInt($el.css("padding-top")) || 0;
    padding.bottom = parseInt($el.css("padding-bottom")) || 0;
    padding.right = parseInt($el.css("padding-right")) || 0;

    return padding;
}

export function getMargins($el) {
    var margin = {};
    margin.left = parseInt($el.css("margin-left")) || 0;
    margin.top = parseInt($el.css("margin-top")) || 0;
    margin.right = parseInt($el.css("margin-right")) || 0;
    margin.bottom = parseInt($el.css("margin-bottom")) || 0;
    return margin;
}

export function constrainValue(value, minValue, maxValue) {
    return Math.min(maxValue, Math.max(minValue, value));
}

export function calcTotalWidth(count, itemWidth, gap) {
    return count * (itemWidth + gap) - gap;
}

export function enumsToItemArray(enums, filter) {
    let items = [];
    if (filter) {
        for (let item of filter) {
            _.each(enums, (value, key) => {
                if (value == item) {
                    items.push({ value: value, label: _.startCase(key.toLowerCase()) });
                }
            });
        }
    } else {
        _.each(enums, (value, key) => {
            items.push({ value: value, label: _.startCase(key.toLowerCase()) });
        });
    }
    return items;
}

export function getShadowStyles(style) {
    // "rgba(0, 0, 0, 0.498039) 2px 2px 5px"

    var colorString = new RegExp("rgba(([^)]+))", "").exec(style)[1].substr(1);
    var rgba = colorString.split(",");

    var values = new RegExp("\\) (.*?)px (.*?)px (.*?)px", "g").exec("rgba(0, 0, 0, 0.498039) 2px 2px 5px");

    var shadow = {
        offsetX: parseInt(values[1]),
        offsetY: parseInt(values[2]),
        blur: parseInt(values[3]),
        rgb: [parseInt(rgba[0]), parseInt(rgba[1]), parseInt(rgba[2])],
        opacity: parseFloat(rgba[3])
    };

    return shadow;
}

export function getBase64Image(img) {
    // Create an empty canvas element
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    // Copy the image contents to the canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // Get the data-URL formatted image
    // Firefox supports PNG and JPEG. You could check img.src to
    // guess the original format, but be aware the using "image/jpg"
    // will re-encode the image.
    var dataURL = canvas.toDataURL("image/png");
    return dataURL;
}

export function elementsFromPoint(x, y) {
    var elements = [],
        previousPointerEvents = [],
        current,
        i,
        d;

    // get all elements via elementFromPoint, and remove them from hit-testing in order
    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {
        // push the element and its current style
        elements.push(current);
        previousPointerEvents.push({
            value: current.style.getPropertyValue("pointer-events"),
            priority: current.style.getPropertyPriority("pointer-events")
        });

        // add "pointer-events: none", to get to the underlying element
        current.style.setProperty("pointer-events", "none", "important");
    }

    // restore the previous pointer-events values
    for (i = previousPointerEvents.length - 1; i >= 0; i--) {
        d = previousPointerEvents[i];
        elements[i].style.setProperty("pointer-events", d.value ? d.value : "", d.priority);
    }

    // return our results
    return elements;
}

export function blendColors(foreColor, backColor) {
    // Fast and easy way to combine (additive mode) two RGBA colors with JavaScript.
    var mix = {};
    mix.a = 1 - (1 - foreColor._a) * (1 - backColor._a); // alpha
    mix.r = Math.round(foreColor._r * foreColor._a / mix.a + backColor._r * backColor._a * (1 - foreColor._a) / mix.a); // red
    mix.g = Math.round(foreColor._g * foreColor._a / mix.a + backColor._g * backColor._a * (1 - foreColor._a) / mix.a); // green
    mix.b = Math.round(foreColor._b * foreColor._a / mix.a + backColor._b * backColor._a * (1 - foreColor._a) / mix.a); // blue

    return tinycolor(mix);
}

export function trackActivity(category, action, label = "none", value = 0, props = {}, { audit } = {}) {
    analytics.track({
        category,
        action,
        label,
        value,
        props,
        audit
    });
}

export function trackActivityViaParams(params) {
    const result = {
        category: null,
        action: null,
        label: "none",
        value: 0,
        props: {},
        audit: null,
        ...params,
    };
    analytics.track(result);
}

export function trackState(props) {
    analytics.trackState(props);
}

export function parseCSV(string, delimiter = "") {
    return Papa.parse(string, { header: false, delimiter: delimiter }).data;
}

export function isValidURL(string) {
    let regEx = /^[a-z](?:[-a-z0-9\+\.])*:(?:\/\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4}:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+[-a-z0-9\._~!\$&'\(\)\*\+,;=:]+)\]|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}|(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*)(?::[0-9]*)?(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*|\/(?:(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*)?|(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD]))*)*|(?!(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])))(?:\?(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\/\?\xA0-\uD7FF\uE000-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDC00-\uDFFD])*)?(?:\#(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~!\$&'\(\)\*\+,;=:@\/\?\xA0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB44-\uDB7E][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F][\uDC00-\uDFFD])*)?$/i;
    return regEx.test(string);
}

export function continuousBinarySearch(start, end, tolerance, fn) {
    let next = (start + end) / 2;
    if (end - start < tolerance) return next;
    return fn(next) ? continuousBinarySearch(start, next, tolerance, fn) : continuousBinarySearch(next, end, tolerance, fn);
}

export function prefixZeros(val, count) {
    const str = val.toString();
    const base = _.times(count, () => "0");
    return [...base.slice(str.length), ...str].join("");
}

// Like Promise.all, but only run `max` promises at once,
// and adds a timeout of `delay` after each promise.
//
// instead of promises, takes zero-argument functions which return
// promises.
export function staggerPromises(fns, max = 1, delay = 0) {
    if (fns.length === 0) return Promise.resolve([]);
    return new Promise((resolve, reject) => {
        let curr = 0;
        let finished = false;
        let results = new Array(fns.length);
        for (let ii = 0; ii < max; ii++) {
            shift();
        }

        function shift() {
            if (finished) return;
            if (curr == fns.length + max - 1) {
                finished = true;
                resolve(results);
            } else {
                let idx = curr++;
                if (idx >= fns.length) return;
                let next = fns[idx]();
                if (!(next.then)) {
                    // wrap plain values to be consistent with Promise.all
                    next = Promise.resolve(next);
                }
                next.then(result => {
                    results[idx] = result;
                    if (delay) {
                        setTimeout(shift, delay);
                    } else {
                        shift();
                    }
                }).catch(err => {
                    finished = true;
                    reject(err);
                });
            }
        }
    });
}

export function downloadFromUrl(url, fileName) {
    return fetch(url)
        .then(resp => resp.blob())
        .then(blob => {
            downloadFromBlob(blob, fileName);
        });
}

export function downloadFromBlob(blob, fileName, contentType = null) {
    if (contentType) {
        blob = new Blob([blob], { type: contentType });
    }
    let blobUrl = window.URL.createObjectURL(blob);
    download(blobUrl, fileName);
    window.URL.revokeObjectURL(blobUrl);
}

export function download(href, fileName) {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = href;
    a.download = fileName;
    a.click();
    a.remove();
}

export function createHash(data, type = "TEXT") {
    let shaObj = new jsSHA("SHA-256", type);
    shaObj.update(data);
    return shaObj.getHash("HEX");
}

export function calculateTimeRemaining(time, options) {
    return extractUnitsFromDuration(time - Date.now());
}

export function calculateTimeElapsed(time, options) {
    return extractUnitsFromDuration(Date.now() - time, options);
}

function extractUnitsFromDuration(duration, { allowNegatives, roundToSecond } = {}) {
    // rounding
    if (roundToSecond) {
        duration = (Math.ceil(duration / 1000) + 1) * 1000;
    }

    const expired = duration <= 0;
    let days = (Math.floor(duration / 1000 / 60 / 60 / 24));
    let hours = (Math.floor(duration / 1000 / 60 / 60)) % 24;
    let minutes = (Math.floor(duration / 1000 / 60)) % 60;
    let seconds = (Math.floor(duration / 1000)) % 60;
    let ms = Math.floor(duration % 1000);

    // zero out negative values
    if (!allowNegatives) {
        days = Math.max(days, 0);
        hours = Math.max(hours, 0);
        minutes = Math.max(minutes, 0);
        seconds = Math.max(seconds, 0);
        ms = Math.max(ms, 0);
    }

    return { days, hours, minutes, seconds, ms, expired };
}

export function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

export function toDataUrl(url) {
    if (!url) {
        return Promise.resolve(null);
    }
    return fetch(url)
        .then(resp => resp.blob())
        .then(blob => {
            return blobToDataURL(blob);
        });
}

export function rand(min, max) {
    return min + Math.round(Math.random() * (max - min));
}

export function getSymbolCmdOrCtrl() {
    return window.navigator.platform.includes("Mac") ? "⌘" : "Ctrl";
}

export function calcEaseInOut(progress) {
    return 1 - (Math.cos(Math.PI * progress) + 1) / 2;
}

export function caseInsensitiveSort(array, getString = item => item) {
    const sorter = (a, b) => {
        const compareA = (getString(a) || "").toString().toLowerCase();
        const compareB = (getString(b) || "").toString().toLowerCase();
        return compareB < compareA ? 1 : -1;
    };

    array.sort(sorter);
    return array;
}

export function cancelPropagation(event) {
    event.stopImmediatePropagation?.();
    event.stopPropagation?.();
}

export function cancelEvent(event) {
    cancelPropagation(event);
    event.preventDefault?.();
}

export { perf };

window.utils = module.exports;
